import React from 'react';
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis,
  CartesianGrid, Tooltip, Legend, LabelList
} from 'recharts';
import { Card, CardText, Button } from "react-bootstrap";

const data = [
  { film: "John Wick",     budget: 20,  gross: 88,   roi: 340 },
  { film: "The Equalizer", budget: 55,  gross: 192,  roi: 249 },
  { film: "Limitless",     budget: 27,  gross: 161,  roi: 496 },
  { film: "Upgrade",       budget: 3,   gross: 16,   roi: 433 },
  { film: "Falling Down",  budget: 25,  gross: 41,   roi: 64  },
];

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const d = payload[0]?.payload;
    return (
      <div style={{
        backgroundColor: 'rgba(20,19,19,0.95)',
        border: '1px solid rgba(243,174,61,0.4)',
        borderRadius: '8px',
        padding: '10px 14px',
        color: '#fff',
        fontSize: '13px',
      }}>
        <p style={{ margin: 0, fontWeight: 'bold', color: '#f3ae3d' }}>{label}</p>
        <p style={{ margin: '4px 0 0' }}>Budget: ${d.budget}M</p>
        {d.gross && <p style={{ margin: '4px 0 0' }}>Worldwide Gross: ${d.gross}M</p>}
        {d.roi && <p style={{ margin: '4px 0 0' }}>ROI: {d.roi}%</p>}
        {!d.gross && <p style={{ margin: '4px 0 0', color: '#f3ae3d' }}>Projected</p>}
      </div>
    );
  }
  return null;
};

export default function CompsChart() {
  return (
    <div  style={{ width: "100%", display: "flex", gap: "1rem", }}>
    <div style={{ flex: 1, position: "relative", minHeight: 0 }}>
        <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          margin={{ top: 10, right: 15, left: -10, bottom: -10 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.1)" />
          <XAxis
            dataKey="film"
            tick={{ fill: '#fff', fontSize: 14 }}
            stroke="rgba(255,255,255,0.3)"
              angle={-25}
            textAnchor="end"
            interval={0}
             height={60}  
          />
          <YAxis
            tickFormatter={(v) => `$${v}M`}
            tick={{ fill: '#fff', fontSize: 14 }}
            stroke="rgba(255,255,255,0.3)"
          />
          <Tooltip content={<CustomTooltip  />} cursor={{ fill: 'rgba(243, 174, 61, 0.1)' }}/>
          <Legend wrapperStyle={{ color: '#fff' }} />
          <Bar dataKey="budget" name="Budget" fill="rgba(179, 37, 25, 0.85)" radius={[4, 4, 0, 0]}>
            <LabelList dataKey="budget" position="top" formatter={(v) => `$${v}M`} style={{ fill: '#fff', fontSize: 14 }} />
          </Bar>
          <Bar dataKey="gross" name="Worldwide Gross" fill="rgb(244, 236, 222, .35)" radius={[4, 4, 0, 0]}>
            <LabelList dataKey="gross" position="top" formatter={(v) => v ? `$${v}M` : '–'} style={{ fill: '#fff', fontSize: 13 }} />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>

<div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "1rem", minHeight: 0, }}>
     <h11 style={{ color: 'white', textAlign: 'center', marginBottom: '0rem' }}>
        Comparable Films — Budget vs. Worldwide Gross (USD Millions)
      </h11>
<ul style={{ color: "white", margin: 0, paddingLeft: '1.2rem', lineHeight: '1.8' }}>
  <li>A combined <strong>$130M</strong> in budgets generated <strong>$498M worldwide</strong> — a blended return of roughly <strong>3.8x</strong>.</li>
  <li>Average ROI across all five titles lands at <strong>316%</strong>.</li>
  <li><strong>Limitless</strong> and <strong>Upgrade</strong> are the standout performers at <strong>496%</strong> and <strong>433% ROI</strong> respectively — Upgrade on a micro-budget of just <strong>$3M</strong>.</li>
  <li><strong>Falling Down</strong> lags at <strong>64% ROI</strong>, yet the overall pattern still reinforces that disciplined, lower-budget action thrillers can consistently outperform on return.</li>
</ul>
</div>
    </div>
  );
}